import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import { routeTo } from 'transfer/utils/routeHelper'
import { paymentTypeUrlMap } from '../../index'
import {
  trackClickUnifiedSend,
  trackGuestReturnToPagePmtChoice,
} from '../../../../../utils/unified-send-analytics'
import content from 'pp-react-l10n'

import { PaymentTypes } from '../alt-pay-styles'
import { mediaQueries } from 'transfer/styles'
import glamorous from 'glamorous'
import PurchaseProtection from '../../purchaseProtectionLink'

import * as UnifiedActions from 'transfer/actions/unified-actions'
import { redirectToDolphin } from '../../../../../actions/unified-actions'
import * as ViewActions from '../../../../../actions/Actions'
import { handleInterstitialCipFlow } from '../../../../../utils/homeInfoUtils'

const {
  phone5PortraitMax: phone320,
  phone6PortraitMax: phone375,
} = mediaQueries
const i18nPaymentType = content('transfer/inc/paymentTypeChoices')

const PaymentTypesToggle = glamorous(PaymentTypes)({
  ':focus': {
    outline: 'none',
  },
  marginLeft: '-8px',
  textAlign: 'center',
  [phone320]: {
    marginTop: '0',
  },
  '& label': {
    marginBottom: '42px',
    [phone375]: {
      marginBottom: '22px',
    },
  },
  '& input[type="radio"]': {
    position: 'absolute',
    zIndex: -100,
    opacity: 0,
    right: '50%',
    top: '50%',
  },
  '& .pp-shield-icon': {
    display: 'none',
  },
  '& .payment-option': {
    cursor: 'pointer',
    display: 'inline-block',
    position: 'relative',
    boxShadow: 'inset 0 0 0 2px #cbd2d6',
    borderRadius: '10px',
    width: '330px',
    minHeight: '67px',
    [phone320]: {
      width: '253px',
      minHeight: '50px',
    },
    '& .v-icon': {
      opacity: 0,
      boxShadow: '4px -3px 0px 2px #fff',
      backgroundColor: '#fff',
      position: 'absolute',
      zIndex: '1',
      top: '-5px',
      right: '-5px',
      width: '36px',
      height: '36px',
    },
    '& .v-icon::before': {
      opacity: 0,
      backgroundColor: 'transparent',
      position: 'absolute',
      top: '1px',
      right: '16px',
      transform: 'rotate(45deg)',
      display: 'block',
      content: '""',
      width: '2px',
      height: '30px',
    },
    '& .v-icon::after': {
      backgroundColor: '#00cf92',
      position: 'absolute',
      top: '22px',
      right: '25px',
      transform: 'rotate(45deg)',
      display: 'block',
      content: '""',
      width: '11px',
      height: '2px',
    },
  },
  '& .send-type-goods ~ .goods-option': {
    [phone375]: {
      marginTop: '-15px',
    },
    '& p': {
      display: 'block',
    },
  },
  '& .send-type-goods:focus ~ .goods-option': {
    boxShadow: '0 0 5px rgba(120, 178, 228, 0.52)',
  },
  '& .send-type-personal:focus ~ .personal-option': {
    boxShadow: '0 0 5px rgba(120, 178, 228, 0.52)',
  },
  '& .send-type-goods:checked ~ .goods-option': {
    // border: 'solid 2px #00cf92',
    '& .pp-shield-icon': {
      display: 'block',
    },
    '& .v-icon': {
      opacity: 1,
      transition: 'opacity 0.10s ease-in 0.75s',
      '&::before': {
        opacity: 1,
        backgroundColor: '#00cf92',
        transition: 'background-color 0.25s ease-in 0.75s',
      },
    },
  },
  '& .send-type-personal:checked ~ .personal-option': {
    // border: 'solid 2px #00cf92',
    [phone320]: {
      // on iphone 5 the icon overlaps the text
      '& h2': {
        marginTop: '20px',
      },
    },
    '& .v-icon': {
      opacity: 1,
      transition: 'opacity 0.10s ease-in 0.75s',
      '&::before': {
        opacity: 1,
        backgroundColor: '#00cf92',
        transition: 'background-color 0.25s ease-in 0.75s',
      },
    },
    '& p': {
      display: 'block',
    },
  },
  '& .learnMore': {
    fontSize: '13px',
    marginTop: '0',
    [phone375]: {
      marginTop: '3px',
    },
  },
  '& .ctaButton': {
    minWidth: '200px',
    fontWeight: '700',
    marginTop: '42px',
    [phone375]: {
      marginTop: '26px',
    },
  },
})

const PaymentOptionTitle = glamorous.h2({
  fontFamily: 'PayPalSansBig-Light, sans-serif',
  fontSize: '20px',
  textAlign: 'left',
  color: '#2c2e2f',
  margin: 0,
  [phone320]: {
    fontSize: '17px',
    lineHeight: '1',
  },
})

const PaymentOptionText = glamorous.p({
  display: 'none',
  marginTop: '-7px',
  paddingTop: '15px',
  [phone320]: {
    marginTop: '0',
  },
  fontFamily: 'PayPalSansSmall-Regular, sans-serif',
  fontSize: '15px',
  lineHeight: '1.5',
  textAlign: 'left',
  color: '#2c2e2f',
  [phone320]: {
    fontSize: '14px',
    lineHeight: '1.4',
    marginBottom: '0',
  },
})

const AnimatedBorder = glamorous.div({
  transition: 'color 0.25s',
  padding: '24px',
  [phone320]: {
    padding: '15px',
  },
  '&::before, &::after': {
    boxSizing: 'border-box',
    position: 'absolute',
    content: '""',
    border: '2px solid transparent',
    borderRadius: '10px 0 10px 10px',
    width: '0',
    height: '0',
  },
  '&::before': {
    bottom: '0',
    left: '0',
  },
  '&::after': {
    right: '0',
    top: '30px', // shift for v-icon square
  },
  '.send-type-goods:checked ~ .payment-option > &::after, .send-type-personal:checked ~ .payment-option > &::after': {
    width: '100%',
    height: 'calc(100% - 30px)', // shift for v-icon square
    borderBottomColor: '#00cf92',
    borderRightColor: '#00cf92',
    transition:
      'border-color 0s ease-in 0.15s, width 0.15s ease-in 0.3s, height 0.15s ease-in 0.15s',
  },
  '.send-type-goods:checked ~ .payment-option > &::before, .send-type-personal:checked ~ .payment-option > &::before': {
    width: 'calc(100% - 30px)', // shift for v-icon square
    height: '100%',
    borderTopColor: '#00cf92',
    borderLeftColor: '#00cf92',
    transition:
      'border-color 0s ease-in 0.45s, width 0.15s ease-in 0.60s, height 0.15s ease-in 0.45s',
  },
})

export class PaymentTypeChoice extends React.Component {
  // this function test if we are changing the previously chosen payment type
  determineLocation = () => {
    if (window.location.pathname.indexOf('send/preview') !== -1) {
      return ['personal', false]
    } else if (window.location.pathname.indexOf('buy/preview') !== -1) {
      return ['goods', true]
    }

    if (this.props.flowType === 'payRequest') {
      return this.props.isPurchase ? ['goods', true] : ['personal', false]
    }
    return [null, null]
  }

  state = {
    isPurchase: this.determineLocation()[1],
    radioValue: this.determineLocation()[0],
  }

  url = null
  targetFlowType = this.props.flowType

  // we route on unmount because if we route immediately after dispatching the action to close the overpanel,
  // it's too fast and the overpanel stays attached to the DOM.. so we let the overpanel unmounting do the routing
  componentWillUnmount() {
    // Redirect to Dolphin Flow After Payment Type Selection if the user has no confirmed phone and falls in the treatment
    const {
      triggerSenderPhoneConfirmation,
      amount,
      currencyCode,
      payerId,
      recipient,
      displayName,
      thumbnailUrl,
    } = this.props
    if (
      this.props.flowType !== 'payRequest' &&
      triggerSenderPhoneConfirmation
    ) {
      const flowType = this.targetFlowType
      const data = {
        flowType,
        amount,
        currencyCode,
        payerId,
        recipient,
        displayName,
        thumbnailUrl,
      }
      this.props.dispatch(redirectToDolphin(data))
    } else if (this.url && this.url !== 'payRequest') {
      routeTo(this.url)
    }
  }

  componentDidMount() {
    if (
      this.props.flowType === 'payRequest' &&
      this.props.paymentTypeIsSelected
    ) {
      return
    }

    let pathName = window.location.pathname
    if (
      pathName.indexOf('send/preview') === -1 &&
      pathName.indexOf('buy/preview') === -1
    ) {
      setTimeout(() => {
        this.startAnimation()
      }, 250)
    }
  }

  startAnimation() {
    this.setState({ isPurchase: true, radioValue: 'goods' })
  }

  handleCloseForOtherFlow = targetFlowType => {
    let shouldUpdateTransactionData = false

    if (this.props.flowType === 'payRequest') {
      if (!this.props.paymentTypeIsSelected) {
        shouldUpdateTransactionData = true
      } else {
        const preFlowType = this.props.isPurchase ? 'buy' : 'send'
        if (preFlowType !== targetFlowType) {
          shouldUpdateTransactionData = true
        }
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }

    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      shouldUpdateTransactionData = true
      this.targetFlowType = targetFlowType
      let pageAction
      if (this.props.isGuest) {
        pageAction =
          targetFlowType === 'send' ? 'guestSelectFF' : 'guestSelectGS'
      } else {
        pageAction = targetFlowType === 'send' ? 'selectFF' : 'selectGS'
      }

      trackClickUnifiedSend(pageAction)

      this.props.dispatch(
        UnifiedActions.changedPurchaseProtection({
          currentPurchaseProtection: targetFlowType === 'buy',
          changedPurchaseProtection: true,
        })
      )
      if (this.props.isGuest) {
        trackGuestReturnToPagePmtChoice(pageAction)
      }
    }

    this.props.handleCloseForOtherFlow(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === 'buy',
    })
  }

  handleSubmit = e => {
    let targetFlowType = this.state.isPurchase ? 'buy' : 'send'

    let shouldUpdateTransactionData = false

    if (this.props.isPersonalDisabled && targetFlowType === 'send') {
      return handleInterstitialCipFlow(targetFlowType)
    }
    if (this.props.isPurchaseDisabled && targetFlowType === 'buy') {
      return handleInterstitialCipFlow(targetFlowType)
    }

    // the handleClose is closely coupled to send flow
    // this is hack for other flows so that we do not need to do the routing
    if (this.props.handleCloseForOtherFlow) {
      return this.handleCloseForOtherFlow(targetFlowType)
    }

    const url =
      this.props.flowType !== 'payRequest'
        ? paymentTypeUrlMap[targetFlowType]
        : 'payRequest'

    if (this.props.flowType === 'payRequest') {
      if (!this.props.paymentTypeIsSelected) {
        shouldUpdateTransactionData = true
      } else {
        const preFlowType = this.props.isPurchase ? 'buy' : 'send'
        if (preFlowType !== targetFlowType) {
          shouldUpdateTransactionData = true
        }
      }
    } else if (targetFlowType && targetFlowType !== this.props.flowType) {
      shouldUpdateTransactionData = true
    }
    // don't do anything unless target flow is different from current
    if (shouldUpdateTransactionData) {
      this.url = url
      this.targetFlowType = targetFlowType
      shouldUpdateTransactionData = true
      trackClickUnifiedSend('continue')
    }

    this.props.dispatch(ViewActions.setPaymentTypeSelected(true))

    this.props.handleClose(shouldUpdateTransactionData, {
      isPurchase: targetFlowType === 'buy',
    })
  }

  selectInput = purchaseType => {
    trackClickUnifiedSend(purchaseType)
    this.setState({
      isPurchase: purchaseType === 'selectGS',
      radioValue: purchaseType === 'selectGS' ? 'goods' : 'personal',
    })
  }

  render() {
    const { radioValue } = this.state
    const hideShield = {
      opacity: '0',
      display: 'none',
      margin: '10px auto',
      width: '1px',
      transition: 'width .4s ease-out',
    }

    const showShield = {
      opacity: '1',
      display: 'block',
      margin: '10px auto',
      width: '200px',
      height: '160px',
      transition: 'width .4s ease-in, opacity .4s ease-in .4s',
    }

    return (
      <div data-nemo="t3-variant">
        <PaymentTypesToggle tabIndex="-1">
          <label
            htmlFor="sendTypeGoods"
            style={{ width: '100%', position: 'relative' }}
          >
            <input
              type="radio"
              id="sendTypeGoods"
              name="sendType"
              value="{radioValue}"
              checked={radioValue === 'goods'}
              className="send-type-goods"
              onChange={e => this.selectInput('selectGS')}
            />
            <div data-nemo="gscard" className="payment-option goods-option">
              <AnimatedBorder>
                <div>
                  <img
                    alt=""
                    role="presentation"
                    data-testid="ppShield"
                    id="ppShield"
                    style={radioValue === 'goods' ? showShield : hideShield}
                    ref={img => (this.ppShield = img)}
                    src={`${this.props.cdnHostName}/static/p2p/c03/617ef4b1cad4950891059cad035b4cf9/pp_shield.gif`}
                  />
                </div>
                <i className="v-icon" />
                <PaymentOptionTitle>
                  {i18nPaymentType('goods.v1Title')}
                </PaymentOptionTitle>
                <PaymentOptionText>
                  {i18nPaymentType('goods.v1Description')}
                </PaymentOptionText>
              </AnimatedBorder>
            </div>
          </label>
          <label htmlFor="sendTypePersonal" style={{ width: '100%' }}>
            <input
              type="radio"
              id="sendTypePersonal"
              name="sendType"
              value="{radioValue}"
              checked={radioValue === 'personal'}
              onChange={e => this.selectInput('selectFF')}
              className="send-type-personal"
            />
            <div data-nemo="ffcard" className="payment-option personal-option">
              <AnimatedBorder>
                <i className="v-icon" />
                <PaymentOptionTitle>
                  {i18nPaymentType('personal.v1Title')}
                </PaymentOptionTitle>
                <PaymentOptionText>
                  {i18nPaymentType('personal.v1Description')}
                </PaymentOptionText>
              </AnimatedBorder>
            </div>
          </label>
          <div className="learnMore">
            {i18nPaymentType('main.learnMore', {
              purchaseProtectionLink: <PurchaseProtection />,
            })}
          </div>
          <div>
            <button
              data-nemo="continue-btn"
              onClick={this.handleSubmit}
              className="vx_btn ctaButton"
            >
              {i18nPaymentType('main.continue')}
            </button>
          </div>
        </PaymentTypesToggle>
      </div>
    )
  }
}
PaymentTypeChoice.propTypes = {
  /** this is redux dispatch */
  dispatch: PropTypes.func.isRequired,
  flowType: PropTypes.string,
  handleClose: PropTypes.func,
  handleCloseForOtherFlow: PropTypes.func,
  isGuest: PropTypes.bool,
  hasSelectedFundingOption: PropTypes.bool,
  triggerSenderPhoneConfirmation: PropTypes.bool,
  amount: PropTypes.any,
  currencyCode: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  displayName: PropTypes.string,
  recipient: PropTypes.string,
  payerId: PropTypes.string,
  isPurchase: PropTypes.bool,
  paymentTypeIsSelected: PropTypes.bool,
  isPersonalDisabled: PropTypes.bool,
  isPurchaseDisabled: PropTypes.bool,
  cdnHostName: PropTypes.string,
}

export default connect(({ server, transaction, recipient, amount, user }) => ({
  transaction: transaction.isPurchase,
  triggerSenderPhoneConfirmation:
    server.triggerSenderPhoneConfirmation ||
    user.triggerSenderPhoneConfirmation,
  displayName: recipient.displayName,
  thumbnailUrl: recipient.thumbnailUrl,
  amount: amount.amount,
  currencyCode: amount.currencyCode,
  recipient: recipient.recipient,
  payerId: recipient.payerId,
  isPurchase: transaction.isPurchase,
  paymentTypeIsSelected: transaction.paymentTypeIsSelected,
  isPersonalDisabled: user.isPersonalDisabled,
  isPurchaseDisabled: user.isPurchaseDisabled,
  cdnHostName: server.cdnHostName,
}))(PaymentTypeChoice)
